import { Card, Container } from 'reactstrap';
import { StudentRemovalRequestViewLoader } from './parts/StudentRemovalRequestViewLoader';
import { StudentRemovalRequestView } from './parts/StudentRemovalRequestView';
import { ParamInteger } from '../../components/params/ParamInteger';
import { StudentRemovalRequestViewNotFound } from './parts/StudentRemovalRequestViewNotFound';

export function StudentsRemovalRequestView() {
  return (
    <Container fluid>
      <Card className="p-4">
        <ParamInteger
          paramKey="studentRemovalRequestId"
          notFoundComponent={<StudentRemovalRequestViewNotFound />}
        >
          {(studentRemovalRequestId) => (
            <StudentRemovalRequestViewLoader
              studentRemovalRequestId={studentRemovalRequestId}
            >
              {({ data }) => <StudentRemovalRequestView data={data} />}
            </StudentRemovalRequestViewLoader>
          )}
        </ParamInteger>
      </Card>
    </Container>
  );
}
